import type { WindowAppKind } from '../types';

/** Map a window instance id to its app kind for rendering and task labels */
export function inferDesktopApp(windowId: string): WindowAppKind | null {
  if (windowId === 'network-settings') return 'network-settings';
  if (windowId === 'this-pc') return 'this-pc';
  if (windowId === 'recycle-bin') return 'recycle-bin';
  if (windowId.startsWith('command-prompt')) return 'command-prompt';
  return null;
}

export function windowTitle(kind: WindowAppKind): string {
  switch (kind) {
    case 'network-settings':
      return 'Settings';
    case 'command-prompt':
      return 'Command Prompt';
    case 'this-pc':
      return 'This PC';
    case 'recycle-bin':
      return 'Recycle Bin';
    default:
      return '';
  }
}
